export enum Scopes {
  createAllowed = "createAllowed",
  openid = "openid",
  profile = "profile",
  offline_access = "offline_access",
  gating = "gating",
  api = "api",
}
